import { forwardRef, type SVGProps } from 'react';

export type MoonIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const MoonIcon = forwardRef<SVGSVGElement, MoonIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M6.91846 1.05533C7.16892 1.00867 7.42297 1.11888 7.56006 1.33365C7.69669 1.54836 7.6892 1.82457 7.5415 2.03189C6.96546 2.84033 6.62549 3.82371 6.62549 4.88931C6.6258 7.61217 8.8323 9.81974 11.5552 9.81998C12.4973 9.81995 13.3746 9.55124 14.1255 9.09048C14.3428 8.95711 14.6198 8.969 14.8247 9.12076C15.0294 9.27255 15.1213 9.53424 15.0571 9.78091C14.2665 12.8194 11.5121 15.0699 8.22217 15.07C4.31819 15.0699 1.15326 11.9045 1.15283 8.00064C1.15283 4.5407 3.63845 1.66765 6.91846 1.05533ZM5.76611 2.72623C3.77959 3.65154 2.40283 5.66507 2.40283 8.00064C2.40326 11.2142 5.00855 13.8199 8.22217 13.82C10.4134 13.8199 12.3193 12.6051 13.3101 10.8122C12.7544 10.9782 12.1657 11.07 11.5552 11.07C8.14195 11.0697 5.3758 8.30252 5.37549 4.88931C5.37549 4.12754 5.51343 3.39857 5.76611 2.72623Z"
      fill="currentColor"
    />
  </svg>
));

MoonIcon.displayName = 'MoonIcon';
